var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"election-home-card card router-tab-touching-card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.showOfficeSelector)?_c('div',{staticClass:"col-md-3"},[_c('office-select-area')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c(_vm.shownCard,{tag:"component"})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }